// // scheduleData

// export const scheduleItems = [
//   {
//     time: "9:00 AM",
//     title: "Arrival & Registration",
//   },
//   {
//     time: "9:15 AM",
//     title: "Processional Entry (Academic/Leadership Procession)",
//   },
//   {
//     time: "9:25 AM",
//     title: "Opening Prayer / Invocation",
//   },
//   {
//     time: "9:30 AM",
//     title: "National Anthem",
//   },
//   {
//     time: "9:35 AM",
//     title: "Welcome Address",
//   },
//   {
//     time: "9:45 AM",
//     title: "Introduction of Incoming Leaders",
//   },
//   {
//     time: "9:55 AM",
//     title: "Keynote Address",
//   },
//   {
//     time: "10:20 AM",
//     title: "Oath of Office / Swearing-In Ceremony",
//   },
//   {
//     time: "10:40 AM",
//     title: "Investiture (Presentation of Symbols of Office)",
//   },
//   {
//     time: "11:00 AM",
//     title: "Inaugural Address (ULFA President)",
//   },
//   {
//     time: "11:20 AM",
//     title: "Goodwill Messages (Guests / Dignitaries)",
//   },
//   {
//     time: "11:35 AM",
//     title: "Cultural Performance / Musical Interlude",
//   },
//   {
//     time: "11:45 AM",
//     title: "Vote of Thanks",
//   },
//   {
//     time: "11:50 AM",
//     title: "Closing / Recessional / Networking / Refreshments",
//   },
//   {
//     time: "12:00 PM",
//     title: "End of Inauguration Ceremony",
//   },
// ];

// scheduleData

export const scheduleItems = [
  {
    time: "9:00 AM",
    title: "Arrival of Guests & Registration",
  },
  {
    time: "9:15 AM",
    title: "Invocation",
  },
  {
    time: "9:20 AM",
    title: "National Anthem",
  },
  {
    time: "9:25 AM",
    title: "Welcome Address & Recognition of Special Guest",
  },
  {
    time: "9:40 AM",
    title: "Turnover Address",
  },
  {
    time: "9:55 AM",
    title: "Introduction of the Keynote Speaker",
  },
  {
    time: "10:00 AM",
    title: "Keynote Address",
  },
  {
    time: "10:30 AM",
    title: "Induction of Elected Officials & Oath of Office",
  },
  {
    time: "10:55 AM",
    title: "Inaugural Address",
  },
  {
    time: "11:15 AM",
    title: "Official Launch of ULFA Project",
  },
  {
    time: "11:30 AM",
    title: "Remarks from All Co-Launchers",
  },
  {
    time: "11:40 AM",
    title: "Remarks",
  },
  {
    time: "11:50 AM",
    title: "Vote of Thanks",
  },
  {
    time: "11:55 AM",
    title: "Benediction",
  },
];